import { render, staticRenderFns } from "./add-rg-template.vue?vue&type=template&id=1f9cbafd&"
import script from "./add-rg-template.vue?vue&type=script&lang=ts&"
export * from "./add-rg-template.vue?vue&type=script&lang=ts&"
import style0 from "./add-rg-template.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports